import { styled } from 'styled-components'

export const Container = styled.div`
  width: 100%;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div {
    display: flex;
    align-items: center;
    > div {
      margin-right: 10px;
      display: flex;
      align-items: center;
      p {
        margin-right: 5px;
      }
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.28px;
      color: var(--text-secondary, #808080);
    }
  }
`

export const InputIndicatorScale = styled.input<{ color?: string }>`
  border-radius: 5px;
  border: 3px solid ${({ color }) => (color ? color : 'var(--red-40, #e96863)')};
  background: var(--global-white, #fff);
  padding: 8px 12px;
  width: 100px;
  outline: none;
`
export const InputScaleContainer = styled.div`
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  width: 100%;
  background: var(--gray-5, #f7f7f7);
  padding: 20px 24px;
  border-radius: 4px;
  border: 1px solid var(--border-main, #ededed);
`

export const InfinityStyled = styled.div<{
  color?: string
  height?: string
  width?: string
}>`
  border-radius: 50%;
  border: 3px solid ${({ color }) => (color ? color : 'var(--red-40, #e96863)')};
  background: ${({ color }) => (color ? color : 'var(--red-40, #e96863)')};
  padding: 4px;
  width: ${({ width }) => (width ? width : '32px')};
  height: ${({ height }) => (height ? height : '32px')};
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 24px;
    height: 24px;
  }
`

export const LittleText = styled.p`
  margin: 0px;
  margin-top: 10px;

  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.24px;
  color: var(--text-secondary, #808080);
`

export const SignalsSetContainer = styled.div`
  border-radius: 4px;
  border: 1px solid var(--border-main, #ededed);
  padding: 8px;
`

export const SignalHeader = styled.div`
  display: grid;
  grid-template-columns: 30% 70%;
`
export const SignalBody = styled.div`
  display: grid;
  grid-template-columns: 30% 70%;
  align-items: center;
  margin-bottom: 20px;
`
export const SignalSetElement = styled.div`
  display: flex;
  align-items: center;
`

export const SignalLevel = styled.div<{ color?: string }>`
  border-left: 4px solid ${({ color }) => (color ? color : 'gray')};
  border-radius: 3px;
  display: flex;
  align-items: center;
  height: fit-content;
  padding: 4px 6px;
  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 4px;
    border: 1px solid var(--border-main, #ededed);
    background: var(--global-white, #fff);
    width: 40%;
    input {
      width: 65%;
      border: none;
      outline: none;
      font-size: 14px;
      font-style: normal;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.28px;
      padding: 0 8px;
      ::placeholder {
        font-weight: 600;
      }
    }
    
    p {
      margin: 5px;
    }
  }
  > p {
    margin: 0px 5px;
  }
`

export const SignalText = styled.input`
  border-radius: 4px;
  height: 32px;
  padding: 0px 9px;
  border: 1px solid var(--border-main, #ededed);
  background: var(--global-white, #fff);
  color: var(--text-secondary, #808080);
  outline: none;
  text-overflow: ellipsis;
  color: var(--text-main, #1a1a1a);
  ::placeholder {
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.28px;
    color: var(--text-secondary, #808080);
  }
`

export const TitleInput = styled.textarea<{ height?: string }>`
  text-overflow: ellipsis;
  resize: none;
  overflow-y: hidden;
  /* Display/L Semibold */
  font-family: Roboto;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 52px; /* 130% */
  letter-spacing: 0.8px;

  width: 100%;
  border: none;
  outline: none;

  overflow-y: auto;
  word-wrap: break-word;

  color: var(--text-main, #1a1a1a);
  ::placeholder {
    color: var(--text-secondary, #808080);
  }
`

export const DescriptionInput = styled.textarea<{ height?: string }>`
  color: var(--text-main, #1a1a1a);
  text-align: justify;

  /* Paragraph/M */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px; /* 171.429% */
  letter-spacing: 0.28px;

  margin: 25px 0px;

  resize: none;
  overflow: hidden;

  height: ${({ height }) => (height ? height : 'fit-content')};
  width: 100%;
  border: none;
  outline: none;
`
